import Plans from './index'
import PlansData from './components/planData/planData.vue'
export default [
  {
    path: '/plans',
    component: Plans
  },
  {
    path: '/plans/entry',
    name: '/plans/entry',
    component: PlansData,
    props: (route) => ({
      id: route.query.id,
      mode: route.params.mode
    })
  }
]
